import Vue from "vue";
/**
 * setting
 * @method setTitle
 * @method setMsg
 * @method setBtnOk
 * @method setTag
 * @method clearText
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickOk
 * @method onHidden
 * event
 * @event sendCallbackOk
 * @event sendCallbackHidden
 */
export function LoadingModalController () {
    this.title = '';
    this.msg = '';
    this.btnOk = '';
    this.tag = '',
    this.busModal = new Vue();

    this.callbackOk = null;
    this.callbackHidden = null;

    //#region setter
    this.setTitle = function(title) {
        this.title = title;
        return this;
    };
    this.setMsg = function(msg) {
        this.msg = msg;
        return this;
    };
    this.setBtnOk = function(btnOk) {
        this.btnOk = btnOk;
        return this;
    };
    this.setTag = function(tag) {
        this.tag = tag;
        return this;
    };
    this.clearText = function() {
        this.title = '';
        this.msg = '';
        this.btnOk = '';
        this.tag = '';
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            title: this.title,
            msg: this.msg,
            btnOk: this.btnOk,
            tag: this.tag,
        };
        this.busModal.$emit('show', config);
    };
    this.hide = function() {
        this.busModal.$emit('hide');
    };
    //#endregion method

    //#region event
    this.onClickOk = function(callback) {
        if (typeof callback == 'function') {
            this.callbackOk = callback;
        }
    },
    this.sendCallbackOk = function(data) {
        if (typeof this.callbackOk == 'function') {
            this.callbackOk(data);
        }
    };

    this.onHidden = function(callback) {
        if (typeof callback == 'function') {
            this.callbackHidden = callback;
        }
    };
    this.sendCallbackHidden = function(data) {
        if (typeof this.callbackHidden == 'function') {
            this.callbackHidden(data);
        }
    };
    //#endregion event
}
